import { render } from "./SingleOrder.vue?vue&type=template&id=412ea900&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"

import "./SingleOrder.vue?vue&type=style&index=0&id=412ea900&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412ea900"]])

export default __exports__